var UsageType;
(function (UsageType) {
    UsageType[UsageType["None"] = 0] = "None";
    UsageType[UsageType["ManufacturingMaterialWithdrawal"] = 1] = "ManufacturingMaterialWithdrawal";
    UsageType[UsageType["PurchaseOrder"] = 2] = "PurchaseOrder";
    UsageType[UsageType["ArrivalReporting"] = 4] = "ArrivalReporting";
    UsageType[UsageType["CustomerOrder"] = 8] = "CustomerOrder";
    UsageType[UsageType["DeliveryReporting"] = 16] = "DeliveryReporting";
    UsageType[UsageType["PhysicalInventoryAndStockReporting"] = 32] = "PhysicalInventoryAndStockReporting";
    UsageType[UsageType["StatisticalUnit"] = 64] = "StatisticalUnit";
    UsageType[UsageType["PackForDelivery"] = 128] = "PackForDelivery";
})(UsageType || (UsageType = {}));
export default UsageType;
